import React, { useState } from 'react'
import { useEffect } from 'react';
import { useRef } from 'react';
import { FaBars, FaChartLine, FaCog, FaFileContract, FaGavel , FaTachometerAlt, FaTimes, FaUsers } from 'react-icons/fa';
import { NavLink, Outlet, useLocation } from 'react-router-dom'
import '../assets/css/DMS.css';
import { useDMSContext } from '../context/DMSContext';

export default function DMSPage() {
  const { sidebarOpen, toggleSidebar } = useDMSContext();
  const location = useLocation();
  const sidebarRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        if (sidebarOpen) toggleSidebar();
      }
    }
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen, toggleSidebar]);
  

  const pageTitles = {
    '/dms/dashboard': 'Dashboard',
    '/dms/debtors': 'Debitori',
    '/dms/contracts': 'Contracte',
    '/dms/claims': 'Pretenții',
    '/dms/reports': 'Rapoarte',
    '/dms/settings': 'Setări',
  };

  const currentTitle = Object.entries(pageTitles).find(([path]) =>
  location.pathname.startsWith(path)
)?.[1] || '';
  return (
    <>
      <nav ref={sidebarRef} className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <button className="sidebar-toggle" onClick={toggleSidebar}>
            <FaTimes size={22} />
          </button>
        </div>
          <ul>
              <li onClick={toggleSidebar}><NavLink to="dashboard"><FaTachometerAlt size={22}/> Dashboard</NavLink></li>
              <li onClick={toggleSidebar}><NavLink to="debtors"><FaUsers size={22}/> Debitori</NavLink></li>
              <li onClick={toggleSidebar}><NavLink to="contracts"><FaFileContract size={22}/> Contracte</NavLink></li>
              <li onClick={toggleSidebar}><NavLink to="claims"><FaGavel size={22}/> Pretenții</NavLink></li>
              <li onClick={toggleSidebar}><NavLink to="reports"><FaChartLine size={22}/> Rapoarte</NavLink></li>
              <li onClick={toggleSidebar}><NavLink to="settings"><FaCog size={22}/> Setări</NavLink></li>
          </ul>
      </nav>

      <main className="content">
        {currentTitle && (
          <div className="page-title">
            <button className="sidebar-toggle" onClick={toggleSidebar}>
              {sidebarOpen ? <FaTimes size={22}/> : <FaBars size={22}/>}
            </button>
            <h2>{currentTitle}</h2>
          </div>
        )}
        <Outlet/>
      </main>
    </>
  );
}
